export default "__VITE_ASSET__b2cf9414__"